/**
 * Le dernier éditeur de texte riche où l'on a mis le curseur, et le bloc Puck
 * qui le porte : la sidebar en tire sa section « Texte », miroir de la bubble.
 * Il reste actif après le blur — cliquer dans la sidebar fait perdre le focus
 * à l'éditeur, et c'est justement là qu'on veut agir sur son texte. Il cesse
 * de l'être au clic sur le canvas hors d'un texte, ou à Échap.
 */
let active = null;
const listeners = new Set();
const watchedDocuments = new WeakSet();

const notify = () => listeners.forEach((listener) => listener());

const deactivate = () => {
  active = null;
  notify();
};

/* Le document du canvas (iframe), pas celui de la sidebar : un clic dans la
   sidebar ne doit pas faire disparaître la section. */
function watchCanvasDocument(doc) {
  if (!doc || watchedDocuments.has(doc)) return;
  watchedDocuments.add(doc);
  doc.addEventListener('mousedown', (event) => {
    // Un autre texte prend le relais à son focus.
    if (!active || event.target.closest?.('.ProseMirror')) return;
    deactivate();
  }, true);
  doc.addEventListener('keydown', (event) => {
    if (!active || event.key !== 'Escape') return;
    active.editor.commands.blur();
    deactivate();
  }, true);
}

export function setActiveRichTextEditor(entry) {
  if (active?.editor === entry.editor && active?.id === entry.id) return;
  active = entry;
  watchCanvasDocument(entry.editor.view?.dom?.ownerDocument);
  notify();
}

export function clearActiveRichTextEditor(editor) {
  if (active?.editor !== editor) return;
  deactivate();
}

export function getActiveRichTextEditor() {
  return active;
}

export function subscribeActiveRichTextEditor(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
